import PriceItemFilter from "./PriceItemFilter";
import "./ProductsFilter.scss";

interface Filter {
  filter_label: string;
  filter_children: {
    value_label: string;
    value_key: string;
    value_active: boolean;
    value_number: number;
  }[];
  filter_key: string;
  filter_type: string;
  filter_active: boolean;
}

const ProductsFilter = ({
  minPrice,
  maxPrice,
  filtersData,
  handleFilterToggle,
  handlePriceChange,
  searchParams,
}: any) => {
  return (
    <div className="Filters-Box">
      {filtersData.map((flt: Filter) => (
        <div key={flt.filter_key} className="Filters-Item">
          <h5 className="Filter-Item-Label">{flt.filter_label}</h5>
          {flt.filter_type === "scroll" ? (
            (() => {
              return (
                <PriceItemFilter
                  minDefault={flt.filter_children[0].value_number}
                  maxDefault={flt.filter_children[1].value_number}
                  minPrice={minPrice}
                  maxPrice={maxPrice}
                  changePrice={handlePriceChange}
                />
              );
            })()
          ) : (
            <div className="Filter-Item-Checkbox-List">
              {flt.filter_children.map((child) => (
                <div className="Filter-Item-Checkbox" key={child.value_key}>
                  <input
                    type="checkbox"
                    className="Checkbox-Box"
                    checked={searchParams
                      .getAll(flt.filter_key)
                      .includes(child.value_label)}
                    onChange={() =>
                      handleFilterToggle(flt.filter_key, child.value_label)
                    }
                  />
                  <label key={child.value_key} className="Checkbox-Label">
                    {child.value_label}
                  </label>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
export default ProductsFilter;
